import {classNames as $6e6392558d48dfec$export$ce4ab0c55987d1ff} from "../utils/classNames.mjs";
import "./combobox.css";
import $hKTE3$combobox_cssmjs from "./combobox_css.mjs";
import {dimensionValue as $63d03c54ca5e4b88$export$abc24f5b99744ea6} from "../utils/styleProps.mjs";
import {Field as $adcd096854d27620$export$a455218a85c89869} from "../label/Field.mjs";
import {FieldButton as $9b445aa2bd8cce4c$export$47dc48f595b075da} from "../button/FieldButton.mjs";
import $hKTE3$intlStringsmjs from "./intlStrings.mjs";
import {ListBoxBase as $ee13b4eccaed924f$export$1afdcf349979fb7e, useListBoxLayout as $ee13b4eccaed924f$export$25768ea656ae32a7} from "../listbox/ListBoxBase.mjs";
import {MobileComboBox as $5815f9078a56ef80$export$7637df911c069b4d} from "./MobileComboBox.mjs";
import {Popover as $3a473e3b7032f626$export$5b6b19405a83ff9d} from "../overlays/Popover.mjs";
import {ProgressCircle as $1cfe37e7feefa23d$export$c79b9d6b4cc92af7} from "../progress/ProgressCircle.mjs";
import "../inputgroup_vars.css";
import $hKTE3$inputgroup_vars_cssmjs from "../inputgroup_vars_css.mjs";
import {TextFieldBase as $b312f2102feb9487$export$d22444a338b6e3c2} from "../textfield/TextFieldBase.mjs";
import "../textfield_vars.css";
import $hKTE3$textfield_vars_cssmjs from "../textfield_vars_css.mjs";
import {useFocusableRef as $3c2c983d5210446c$export$96a734597687c040, useUnwrapDOMRef as $3c2c983d5210446c$export$1d5cc31d9d8df817} from "../utils/useDOMRef.mjs";
import {useFormProps as $c29c48d4ef19ffc4$export$a6b5be5c6b451665} from "../form/Form.mjs";
import {useIsMobileDevice as $f357d4aae54bf1ff$export$736bf165441b18c7} from "../utils/useIsMobileDevice.mjs";
import {useProvider as $71dfb0e0358a12de$export$693cdb10cec23617, useProviderProps as $71dfb0e0358a12de$export$521c373ccc32c300} from "../provider/Provider.mjs";
import {useComboBox as $hKTE3$useComboBox} from "react-aria/useComboBox";
import $hKTE3$spectrumiconsuiChevronDownMedium from "@spectrum-icons/ui/ChevronDownMedium";
import {useComboBoxState as $hKTE3$useComboBoxState} from "react-stately/useComboBoxState";
import {FocusRing as $hKTE3$FocusRing} from "react-aria/FocusRing";
import {PressResponder as $hKTE3$PressResponder} from "react-aria/private/interactions/PressResponder";
import $hKTE3$react, {useRef as $hKTE3$useRef, useEffect as $hKTE3$useEffect, useState as $hKTE3$useState, useCallback as $hKTE3$useCallback} from "react";
import {useFilter as $hKTE3$useFilter} from "react-aria/useFilter";
import {useHover as $hKTE3$useHover} from "react-aria/useHover";
import {useLayoutEffect as $hKTE3$useLayoutEffect} from "react-aria/private/utils/useLayoutEffect";
import {useLocalizedStringFormatter as $hKTE3$useLocalizedStringFormatter} from "react-aria/useLocalizedStringFormatter";
import {useResizeObserver as $hKTE3$useResizeObserver} from "react-aria/private/utils/useResizeObserver";


function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 



























const $7615e9b07e5d1703$export$72b9695b8216309a = /*#__PURE__*/ (0, $hKTE3$react).forwardRef(function ComboBox(props, ref) {
    props = (0, $71dfb0e0358a12de$export$521c373ccc32c300)(props);
    props = (0, $c29c48d4ef19ffc4$export$a6b5be5c6b451665)(props);
    let hasWarned = (0, $hKTE3$useRef)(false);
    (0, $hKTE3$useEffect)(()=>{
        if (props.placeholder && !hasWarned.current && process.env.NODE_ENV !== 'production') {
            console.warn('Placeholders are deprecated due to accessibility issues. Please use help text instead. See the docs for details: https://react-spectrum.adobe.com/react-spectrum/ComboBox.html#help-text');
            hasWarned.current = true;
        }
    }, [
        props.placeholder
    ]);
    let isMobile = (0, $f357d4aae54bf1ff$export$736bf165441b18c7)();
    if (isMobile) // menuTrigger=focus/manual don't apply to mobile combobox
    return /*#__PURE__*/ (0, $hKTE3$react).createElement((0, $5815f9078a56ef80$export$7637df911c069b4d), {
        ...props,
        menuTrigger: "input",
        ref: ref
    });
    else return /*#__PURE__*/ (0, $hKTE3$react).createElement($7615e9b07e5d1703$var$ComboBoxBase, {
        ...props,
        ref: ref
    });
});
const $7615e9b07e5d1703$var$ComboBoxBase = /*#__PURE__*/ (0, $hKTE3$react).forwardRef(function ComboBoxBase(props, ref) {
    let { menuTrigger: menuTrigger = 'input', shouldFlip: shouldFlip = true, direction: direction = 'bottom', align: align = 'start', isQuiet: isQuiet, loadingState: loadingState, onLoadMore: onLoadMore, allowsCustomValue: allowsCustomValue, menuWidth: customMenuWidth, name: name, formValue: formValue = 'text' } = props;
    if (allowsCustomValue) formValue = 'text';
    let stringFormatter = (0, $hKTE3$useLocalizedStringFormatter)((0, ($parcel$interopDefault($hKTE3$intlStringsmjs))), '@react-spectrum/combobox');
    let isAsync = loadingState != null;
    let popoverRef = (0, $hKTE3$useRef)(null);
    let unwrappedPopoverRef = (0, $3c2c983d5210446c$export$1d5cc31d9d8df817)(popoverRef);
    let buttonRef = (0, $hKTE3$useRef)(null);
    let unwrappedButtonRef = (0, $3c2c983d5210446c$export$1d5cc31d9d8df817)(buttonRef);
    let listBoxRef = (0, $hKTE3$useRef)(null);
    let inputRef = (0, $hKTE3$useRef)(null);
    // serve as the new popover `triggerRef` instead of `unwrappedButtonRef` before for better positioning.
    let inputGroupRef = (0, $hKTE3$useRef)(null);
    let domRef = (0, $3c2c983d5210446c$export$96a734597687c040)(ref, inputRef);
    let { contains: contains } = (0, $hKTE3$useFilter)({
        sensitivity: 'base'
    });
    let state = (0, $hKTE3$useComboBoxState)({
        ...props,
        defaultFilter: contains,
        allowsEmptyCollection: isAsync
    });
    let layout = (0, $ee13b4eccaed924f$export$25768ea656ae32a7)();
    let { buttonProps: buttonProps, inputProps: inputProps, listBoxProps: listBoxProps, labelProps: labelProps, descriptionProps: descriptionProps, errorMessageProps: errorMessageProps, isInvalid: isInvalid, validationErrors: validationErrors, validationDetails: validationDetails } = (0, $hKTE3$useComboBox)({
        ...props,
        layoutDelegate: layout,
        buttonRef: unwrappedButtonRef,
        popoverRef: unwrappedPopoverRef,
        listBoxRef: listBoxRef,
        inputRef: inputRef,
        menuTrigger: menuTrigger,
        name: formValue === 'text' ? name : undefined
    }, state);
    // Measure the width of the inputfield and the button to inform the width of the menu (below).
    let [menuWidth, setMenuWidth] = (0, $hKTE3$useState)(undefined);
    let { scale: scale } = (0, $71dfb0e0358a12de$export$693cdb10cec23617)();
    let onResize = (0, $hKTE3$useCallback)(()=>{
        if (unwrappedButtonRef.current && inputRef.current) {
            let buttonWidth = unwrappedButtonRef.current.offsetWidth;
            let inputWidth = inputRef.current.offsetWidth;
            setMenuWidth(buttonWidth + inputWidth);
        }
    }, [
        unwrappedButtonRef,
        inputRef,
        setMenuWidth
    ]);
    (0, $hKTE3$useResizeObserver)({
        ref: domRef,
        onResize: onResize
    });
    (0, $hKTE3$useLayoutEffect)(onResize, [
        scale,
        onResize
    ]);
    let width = isQuiet ? undefined : menuWidth;
    let style = {
        width: customMenuWidth ? (0, $63d03c54ca5e4b88$export$abc24f5b99744ea6)(customMenuWidth) : width,
        minWidth: isQuiet ? `calc(${menuWidth}px + calc(2 * var(--spectrum-dropdown-quiet-offset)))` : menuWidth
    };
    let cbInputProps = {
        ...props,
        children: null
    };
    return /*#__PURE__*/ (0, $hKTE3$react).createElement((0, $hKTE3$react).Fragment, null, /*#__PURE__*/ (0, $hKTE3$react).createElement((0, $adcd096854d27620$export$a455218a85c89869), {
        ...props,
        descriptionProps: descriptionProps,
        errorMessageProps: errorMessageProps,
        isInvalid: isInvalid,
        validationErrors: validationErrors,
        validationDetails: validationDetails,
        labelProps: labelProps,
        ref: domRef
    }, /*#__PURE__*/ (0, $hKTE3$react).createElement($7615e9b07e5d1703$var$ComboBoxInput, {
        ...cbInputProps,
        isOpen: state.isOpen,
        loadingState: loadingState,
        inputProps: inputProps,
        inputRef: inputRef,
        triggerProps: buttonProps,
        triggerRef: buttonRef,
        validationState: props.validationState || (isInvalid ? 'invalid' : undefined),
        ref: inputGroupRef
    })), name && formValue === 'key' && /*#__PURE__*/ (0, $hKTE3$react).createElement("input", {
        type: "hidden",
        name: name,
        form: props.form,
        value: state.selectedKey ?? ''
    }), /*#__PURE__*/ (0, $hKTE3$react).createElement((0, $3a473e3b7032f626$export$5b6b19405a83ff9d), {
        state: state,
        UNSAFE_style: style,
        UNSAFE_className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($hKTE3$inputgroup_vars_cssmjs))), 'spectrum-InputGroup-popover', {
            'spectrum-InputGroup-popover--quiet': isQuiet
        }),
        ref: popoverRef,
        triggerRef: inputGroupRef,
        scrollRef: listBoxRef,
        placement: `${direction} ${align}`,
        hideArrow: true,
        isNonModal: true,
        shouldFlip: shouldFlip
    }, /*#__PURE__*/ (0, $hKTE3$react).createElement((0, $ee13b4eccaed924f$export$1afdcf349979fb7e), {
        ...listBoxProps,
        ref: listBoxRef,
        disallowEmptySelection: true,
        shouldSelectOnPressUp: true,
        focusOnPointerEnter: true,
        layout: layout,
        state: state,
        shouldUseVirtualFocus: true,
        isLoading: loadingState === 'loading' || loadingState === 'loadingMore',
        showLoadingSpinner: loadingState === 'loadingMore',
        onLoadMore: onLoadMore,
        renderEmptyState: ()=>isAsync && /*#__PURE__*/ (0, $hKTE3$react).createElement("span", {
                className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($hKTE3$combobox_cssmjs))), 'no-results')
            }, loadingState === 'loading' ? stringFormatter.format('loading') : stringFormatter.format('noResults'))
    })));
});
const $7615e9b07e5d1703$var$ComboBoxInput = /*#__PURE__*/ (0, $hKTE3$react).forwardRef(function ComboBoxInput(props, ref) {
    let { isQuiet: isQuiet, isDisabled: isDisabled, validationState: validationState, inputProps: inputProps, inputRef: inputRef, triggerProps: triggerProps, triggerRef: triggerRef, autoFocus: autoFocus, style: style, className: className, loadingState: loadingState, isOpen: isOpen, menuTrigger: menuTrigger } = props;
    let { hoverProps: hoverProps, isHovered: isHovered } = (0, $hKTE3$useHover)({});
    let stringFormatter = (0, $hKTE3$useLocalizedStringFormatter)((0, ($parcel$interopDefault($hKTE3$intlStringsmjs))), '@react-spectrum/combobox');
    let timeout = (0, $hKTE3$useRef)(null);
    let [showLoading, setShowLoading] = (0, $hKTE3$useState)(false);
    let loadingCircle = /*#__PURE__*/ (0, $hKTE3$react).createElement((0, $1cfe37e7feefa23d$export$c79b9d6b4cc92af7), {
        "aria-label": stringFormatter.format('loading'),
        size: "S",
        isIndeterminate: true,
        UNSAFE_className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($hKTE3$textfield_vars_cssmjs))), 'spectrum-Textfield-circleLoader', (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($hKTE3$inputgroup_vars_cssmjs))), 'spectrum-InputGroup-input-circleLoader'))
    });
    let isLoading = loadingState === 'loading' || loadingState === 'filtering';
    let inputValue = inputProps.value;
    let lastInputValue = (0, $hKTE3$useRef)(inputValue);
    (0, $hKTE3$useEffect)(()=>{
        if (isLoading && !showLoading) {
            if (timeout.current === null) timeout.current = setTimeout(()=>{
                setShowLoading(true);
            }, 500);
            // If user is typing, clear the timer and restart since it is a new request
            if (inputValue !== lastInputValue.current) {
                clearTimeout(timeout.current);
                timeout.current = setTimeout(()=>{
                    setShowLoading(true);
                }, 500);
            }
        } else if (!isLoading) {
            if (timeout.current) clearTimeout(timeout.current);
            timeout.current = null;
        }
        lastInputValue.current = inputValue;
    }, [
        isLoading,
        showLoading,
        inputValue
    ]);
    let [prevIsLoading, setPrevIsLoading] = (0, $hKTE3$useState)(isLoading);
    if (prevIsLoading !== isLoading && !isLoading) {
        setShowLoading(false);
        setPrevIsLoading(isLoading);
    }
    (0, $hKTE3$useEffect)(()=>{
        return ()=>{
            if (timeout.current) clearTimeout(timeout.current);
            timeout.current = null;
        };
    }, []);
    return /*#__PURE__*/ (0, $hKTE3$react).createElement((0, $hKTE3$FocusRing), {
        within: true,
        isTextInput: true,
        focusClass: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($hKTE3$inputgroup_vars_cssmjs))), 'is-focused'),
        focusRingClass: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($hKTE3$inputgroup_vars_cssmjs))), 'focus-ring'),
        autoFocus: autoFocus
    }, /*#__PURE__*/ (0, $hKTE3$react).createElement("div", {
        ...hoverProps,
        ref: ref,
        style: style,
        className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($hKTE3$inputgroup_vars_cssmjs))), 'spectrum-InputGroup', {
            'spectrum-InputGroup--quiet': isQuiet,
            'is-disabled': isDisabled,
            'spectrum-InputGroup--invalid': validationState === 'invalid' && !isDisabled,
            'is-hovered': isHovered
        }, className)
    }, /*#__PURE__*/ (0, $hKTE3$react).createElement((0, $b312f2102feb9487$export$d22444a338b6e3c2), {
        inputProps: inputProps,
        inputRef: inputRef,
        UNSAFE_className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($hKTE3$inputgroup_vars_cssmjs))), 'spectrum-InputGroup-field'),
        inputClassName: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($hKTE3$inputgroup_vars_cssmjs))), 'spectrum-InputGroup-input'),
        validationIconClassName: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($hKTE3$inputgroup_vars_cssmjs))), 'spectrum-InputGroup-input-validationIcon'),
        isDisabled: isDisabled,
        isQuiet: isQuiet,
        validationState: validationState,
        // loading circle should only be displayed if menu is open, if menuTrigger is "manual", or first time load (to stop circle from showing up when user selects an option)
        // TODO: add special case for completionMode: complete as well
        isLoading: showLoading && (isOpen || menuTrigger === 'manual' || loadingState === 'loading'),
        loadingIndicator: loadingState != null ? loadingCircle : undefined,
        disableFocusRing: true
    }), /*#__PURE__*/ (0, $hKTE3$react).createElement((0, $hKTE3$PressResponder), {
        preventFocusOnPress: true,
        isPressed: isOpen
    }, /*#__PURE__*/ (0, $hKTE3$react).createElement((0, $9b445aa2bd8cce4c$export$47dc48f595b075da), {
        ...triggerProps,
        ref: triggerRef,
        UNSAFE_className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($hKTE3$inputgroup_vars_cssmjs))), 'spectrum-FieldButton'),
        isQuiet: isQuiet,
        validationState: validationState
    }, /*#__PURE__*/ (0, $hKTE3$react).createElement((0, $hKTE3$spectrumiconsuiChevronDownMedium), {
        UNSAFE_className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($hKTE3$inputgroup_vars_cssmjs))), 'spectrum-Dropdown-chevron')
    })))));
});


export {$7615e9b07e5d1703$export$72b9695b8216309a as ComboBox};
//# sourceMappingURL=ComboBox.mjs.map
